const glossary = {
  adverbs: {
    by: 'by',
    for_more_than_days: 'for more than {{count}} days',
    since: 'since',
    on: 'on',
    as_of: 'as of',
    as_in: 'as in',
    out_of: 'out of',
    per_month: 'per month',
  },
  nouns: {
    '2fa': 'Two-Factor Authentication',
    account: 'account',
    account_name: 'Account Name',
    choose_authentication_method: 'Choose Authentication Method',
    authentication_mode: 'Authentication Mode',
    authentication_method: 'Authentication Method',
    change_password: 'Change Password',
    current_password: 'Current Password',
    authentication_mode_default: 'Default',
    authentication_mode_google: 'Google',
    authentication_mode_office365: 'Microsoft',
    authentication_mode_sso: 'SSO',
    active: 'active',
    actives: 'active',
    active_users: 'active users',
    active_users_capitalized: 'Active users',
    addiction: 'addiction',
    address: {
      line_1: 'address line 1',
      line_2: 'address line 2',
      city: 'city',
      country: 'country',
      postal_code_zip: 'Postal code/ZIP',
      province_state: 'Province/State',
    },
    admin: 'admin',
    advanced: 'Advanced',
    all: 'All',
    annual_instant_validation: 'candidate reports',
    api_key: 'api key',
    available: 'completed',
    report: 'Report', 
    available_pending_twitter: 'Completed, pending Twitter verification',
    available_pending_articles: 'Completed, pending articles verification',
    basic_information: 'Basic information',
    preference_settings: 'Preference settings',
    billing: {
      billing: 'Billing',
      email: 'Billing email',
      billing_information: 'Billing information',
      billing_address: 'Billing address',
      next_payment: 'Next payment',
      payment_details: 'Payment details',
      payment_method: 'Payment method',
      save_changes: 'Save changes',
    },
    plans_and_payments: 'plans',
    city_of_residence: 'city of residence',
    clear: 'clear',
    clear_all: 'clear all filters',
    clear_sorting: 'Clear Sorting',
    coming_soon: 'Available at launch',
    company: 'organization',
    affiliated_organization: 'Affiliated organizations',
    user_reviewed: 'Reviewed',
    reviewed_by: 'Reviewed by',
    pep_soe: 'PEP/SOE',
    validation_list_settings: 'Validation list settings',
    validation_list_columns: 'Columns',
    pep: 'PEP',
    pepDescription:'Politically Exposed Person (PEP)',
    pep_status: {
      not_requested: 'Not requested',
      not_available: 'Not available',
      true: 'PEP identified',
      requested_not_returned: 'Requested, not returned',
      yes: "Yes",
      no: "No",
      hoverHasPep:
        'This entity has been flagged as a Politically Exposed Person (PEP).',
      hoverNoPep:
        'This entity has not been flagged as a Politically Exposed Person (PEP).',
      planIncluded: "PEP (Politically Exposed Person) and SOE (State-Owned Enterprises) analysis included in your plan",
      planNotIncluded: "PEP (Politically Exposed Person) and SOE (State-Owned Enterprises) analysis not included in your plan",
      request_toggle_hint: "When enabled, new validations will include PEP/SOE screening",
      request_toggle_admin_only: "Only company owners and admins can change this setting",
      request_enabled_hint: "PEP/SOE screening is requested on new validations",
      request_disabled_hint: "PEP/SOE screening is not requested on new validations",
      notRequested: "Not Requested",
    },
    soe: 'SOE',
    soeDescription: 'State-Owned Enterprise (SOE)',
    soe_status: {
      not_requested: 'Not requested',
      not_available: 'Not available',
      true: 'SOE identified',
      requested_not_returned: 'Requested, not returned',
      yes: 'Yes',
      no: 'No',
      hoverHasSoe:
        'This entity has been flagged as a State-Owned Enterprise (SOE).',
      hoverNoSoe:
        'This entity has not been flagged as a State-Owned Enterprise (SOE).',
      reportHasPep:
        'This entity has been flagged as a Politically Exposed Person (PEP).',
      reportNoPep:
        'This entity has not been flagged as a Politically Exposed Person (PEP).',
      notSoeValidated: 'Not validated with SOE'
    },
    company_name: 'Organization Name',
    company_plural: 'organizations',
    conduct: 'Risk Indicator',
    report_type: 'Report type',
    connected_as: 'connected as',
    confirm_password: 'Confirm your password',
    consent_status: 'invitation',
    consent_statuses: 'invitations',
    copyright: '© {{year}} Valital Technologies Inc.',
    sso: 'login with SSO',
    // create_password: 'create your password',
    credentials: 'credentials',
    custom: 'custom',
    custom_plan: '<span><strong>Custom</strong> plan</span>',
    dark_mode: 'Dark mode',
    dashboard: 'dashboard',
    delegate: 'user',
    delegate_1: 'a user',
    delegate_plural: 'users',
    department: 'department',
    discrimination: 'discrimination',
    done: 'done',
    downgrade: 'downgrade',
    email: 'Email',
    end_date: 'End date',
    enrolment_period: 'Enrolment period',
    features: 'features',
    fraudraufraudree: 'free',
    from: 'From',
    first_name: 'First Name',
    global_results: 'global results',
    green: 'green',
    harassment: 'harassment',
    help_and_support: 'Help & Support',
    history: 'history',
    high_risk: 'high risk',
    identity_matching: 'identity matching',
    inactive_users: 'inactive users',
    individual: 'Individual',
    organization: 'Organization',
    individual_plural: 'Individuals',
    integrations: 'integrations',
    in: 'in',
    invite: 'invite',
    investigate: 'investigate',
    inconclusive: 'inconclusive',
    invoices: {
      invoices: 'Invoices',
      date: 'Date',
      invoice_number: 'Invoice #',
      status: 'Status',
      amount: 'Amount',
      statuses: {
        paid: 'paid',
        draft: 'draft',
        void: 'void',
        open: 'open',
        uncollectible: 'uncollectible',
      },
      last_payment: 'Last payment',
      payment_amount: 'Payment amount',
    },
    last_name: 'Last Name',
    last_request: 'last request',
    legal: 'legal',
    less: 'less',
    less_likely: 'less likely',
    likely: 'likely',
    live: 'live',
    prefrence_text:
      'Enable or disable liveUpdate by default for all new validations',
    private_validations_by_default: 'Private validations',
    private_validations_by_default_text:
      'Enable or disable private validations by default for all new validations',
    default_validation_settings_title: 'Default validation settings',
    default_validation_settings_subtitle:
      'Set default settings for new validations.',
    default_live_update_settings_title: 'LiveUpdate Default Settings',
    default_live_update_settings_subtitle:
      'Set default settings for new validations.',
    default_validation_live_updates_label: 'LiveUpdate',
    default_validation_live_updates_description:
      'Select your frequency to enable continuous monitoring and get notified for new information. You can override these settings when submitting a validation.',
    default_validation_private_label: 'Private',
    default_validation_private_description:
      'Keep validations private. They will only be visible to Account Owner, Account Admin and Team Admin. You can override these settings when submitting a validation.',
    default_validation_pep_soe_label: 'PEP/SOE',
    default_validation_pep_soe_description:
      'Include flagging of Politically Exposed Persons and State-Owned Enterprises.',
    default_validation_search_languages_label: 'Search languages',
    default_validation_search_languages_description:
      'Valital will search and analyze articles on your entities in the selected languages. You can override these settings when submitting a validation.',
    default_validation_search_languages_saved:
      'Default search languages updated.',
    default_validation_search_languages_min_one:
      'Select at least one search language.',
    default_validation_search_languages_max_four:
      'You can select at most four search languages.',
    validation_search_languages_label: 'Search languages',
    validation_search_languages_description:
      'Select up to four languages to search for this validation.',
    validation_search_languages_saved: 'Search languages updated.',
    validation_search_language_pending: 'pending',
    validation_search_languages_manage: 'Manage',
    validation_search_languages_change: 'Change languages',
    validation_search_languages_pending: 'pending',
    validation_search_languages_pending_hint:
      'Selected but not yet searched — a new run will query this language.',
    validation_search_languages_analyzed_hint:
      'This language has already been searched for this validation.',
    validation_search_languages_historical_hint:
      'Previously searched — articles may exist even if this language is no longer selected.',
    validation_article_languages_label: 'Found',
    validation_list_language_pending:
      'Pending: {{language}}. Selected but not yet searched — a new run will query this language.',
    validation_list_language_found:
      'Found: {{language}}. Articles were found in this language.',
    validation_list_language_searched:
      'Searched: {{language}}. No articles were found in this language.',
    update_preference_settings: 'Update preference settings',
    preference_settings_saved: 'Default validation settings updated',
    preference_settings_save_failed:
      'Could not save settings. Please try again.',
    preference_private_enabled: 'Validations will be private by default.',
    preference_private_disabled: 'Validations will be shared by default.',
    preference_pep_soe_enabled:
      'PEP/SOE will now be enabled in your validations.',
    preference_pep_soe_disabled:
      'PEP/SOE will now be disabled in your validations.',
    preference_live_update_settings_updated:
      'LiveUpdate settings have been updated.',
    live_update: 'LiveUpdate',
    live_validation: 'LiveUpdate',
    validation_labels: 'Labels',
    live_validations: 'LiveUpdate',
    live_validations_enabled: 'LiveUpdate',
    live_validations_disabled: 'LiveUpdate disabled',
    up_to: 'up to {{count}}',
    include_twitter: 'Twitter',
    extend_search: 'Extended Search',
    not_trusted: 'Not trusted',
    location: 'Location',
    locations: 'Locations',
    month: 'month',
    month_plural: 'months',
    most: 'most',
    most_likely: 'most likely',
    name: 'name',
    name_location: 'name & location',
    never: 'never',
    new: 'new',
    new_feminine: 'new',
    new_validation: 'New validation',
    news: 'news',
    next: 'next',
    new_instant_validation: 'Update Validation',
    new_password: 'New password',
    nick_name: 'Alternative First Name (optional)',
    alternative_first_name: 'Alternative First Name (optional)',
    no: 'no',
    notable_themes: 'notable themes',
    notifications: 'notifications',
    off: 'Off',
    ok: 'ok',
    old_password: 'Old password',
    optional: 'optional',
    on: 'on',
    other: 'other',
    other_results: 'other results',
    password: 'password',
    code: 'code',
    pending_consent: 'pending invitation',
    pending_consent_plural: 'pending invitation',
    period_worked: 'period worked',
    personal_info: 'personal information',
    per_month: 'per month',
    phone_number: 'phone number',
    plan: 'plan',
    plans_for_every_org: 'Plans for Every Organization',
    plan_type: '{{planType}} plan',
    plan_validation_number: '<span><strong>Advanced</strong> features</span>',
    positions: 'organizations',
    previous: 'previous',
    pending_verification: 'Preliminary',
    pending_verification_report: 'Preliminary Report',
    pending_articles_verification: 'Pending articles verification',
    pending_twitter_verification: 'Pending twitter verification',
    new_twitter_validation: 'Run new validation <br />with Twitter',
    privacy_email: 'privacy@valital.com',
    privacy_statement: 'Privacy Statement',
    profile: 'profile',
    red: 'red',
    reference_1: 'a reference',
    reference: 'reference',
    references: 'references',
    ready_for_validation: 'Ready for validation',
    individuals_will_appear_here:
      'Your individuals to validate will appear here.',
    organizations_will_appear_here:
      'Your organizations to validate will appear here.',
    reminder: 'reminder',
    report_page: {
      idMatch: 'ID match',
      id_match: 'ID match',
      STRONG: 'STRONG',
      WEAK: 'WEAK',
      article: 'Article',
      article_plural: 'Articles',
      articles: 'Articles',
      LIVE: 'LIVE',
      INSTANT: 'INSTANT',
      source: 'Source',
      CREDIBLE: 'CREDIBLE',
      ALL: 'ALL',
      found_on: 'Found on',
    },
    request: 'request',
    reset_password: 'reset password',
    create_password: 'Create Password',
    risk_indicator: 'Risk Indicator',
    risk: 'Risk',
    role: 'Title',
    role_name: 'Role or Position ',
    role_plural: 'Titles',
    row: 'row',
    row_plural: 'rows',
    security_settings: 'Security',
    selected: 'selected',
    select: 'select',
    settings: 'settings',
    start_date: 'Start Date',
    status: 'status',
    summary: 'summary',
    success: 'success',
    switch_language: 'français',
    talent: 'talent',
    talent_plural: 'talents',
    talent_SECURITY: 'individual',
    talent_SECURITY_plural: 'individuals',
    terms_of_use: 'Terms of Use',
    twitter: 'twitter',
    unavailable: 'unavailable',
    upgrade: 'upgrade',
    user: 'user',
    usage_and_credits: 'Subscription & Usage',
    pay_as_you_go: 'Pay as you go',
    usage_dashboard_title: 'Subscription & Usage',
    usage_dashboard_subtitle:
      'Monitor your subscription and usage. All dates are in UTC.',
    usage_your_subscription: 'Your subscription',
    usage_credits_used: 'credits used',
    credits_used: 'credits used',
    credits_remaining: 'credits remaining',
    credits_overused_suffix: 'credits overused',
    usage_this_utc_month: 'This month',
    usage_projected_by_renewal: 'Projected by renewal',
    usage_more_from_schedules: 'more from current schedules',
    usage_entities_by_frequency: 'Entities by update frequency',
    usage_scheduled_title: 'Entities',
    usage_entities_heading: 'Entities',
    usage_active_entities_heading: 'Active Entities',
    usage_credit_equals_entity_day: '1 credit = 1 monitored entity for 1 day',
    usage_scheduled_hint:
      'Entities with liveUpdate enabled right now (by frequency). This is not billable usage.',
    usage_schedule_this_month: 'Credit units by schedule (this month)',
    usage_over_subscribed_copy:
      'You have used more than your subscribed credits. liveUpdate and the API continue to run; overage is billed per your agreement.',
    usage_near_limit_copy:
      'You have used 80% or more of your subscribed credits.',
    usage_limit_reached_copy:
      'You have reached 100% of your subscribed credits.',
    usage_paygo_lu_note: 'No upfront credit pool; usage is metered per your agreement.',
    usage_chart_validations_title: 'Validation usage by month',
    usage_chart_validations_subtitle: 'Track your validation consumption over time',
    usage_chart_lu_title: 'LiveUpdate usage by month',
    usage_chart_lu_subtitle: 'Track your liveUpdate credit consumption over time',
    usage_chart_empty: 'No usage data for the selected period.',
    usage_by_day: 'Usage by Day',
    usage_by_week: 'Usage by Week',
    usage_by_month: 'Usage by Month',
    usage_by_year: 'Usage by Year',
    usage_granularity_day: 'Day',
    usage_granularity_week: 'Week',
    usage_granularity_month: 'Month',
    usage_granularity_year: 'Year',
    usage_view_by_month: 'Month',
    usage_previous_subscriptions: 'Previous subscriptions',
    usage_previous_subscriptions_subtitle: 'View your subscription history',
    usage_monthly_history: 'Monthly usage history',
    usage_monthly_history_note:
      'Calendar months from your subscription start. liveUpdate values are credit units (1 per billable run).',
    usage_days_count: '{{count}} days',
    usage_billing_unavailable: 'Usage information is not available for your account.',
    usage_lu_unavailable: 'LiveUpdate billing is not enabled for your account.',
    usage_view_usage_link: 'Subscription & Usage',
    days_until_renewal: 'Days until renewal',
    renewal_date: 'Renewal date',
    start_date: 'Start date',
    credits: 'Credits',
    used: 'used',
    remaining: 'remaining',
    of_subscribed: 'of subscribed',
    daily_live_update: 'Daily LiveUpdate',
    weekly_live_update: 'Weekly LiveUpdate',
    monthly_live_update: 'Monthly LiveUpdate',
    live_update_frequency_daily: 'Daily',
    live_update_frequency_weekly: 'Weekly',
    live_update_frequency_monthly: 'Monthly',
    live_update_credits: 'LiveUpdate credits',
    period: 'Period',
    month: 'Month',
    total: 'Total',
    live_update_last_check: 'Last billable run:',
    live_update_next_check: 'Next scheduled check (estimate):',
    live_update_next_tooltip_at_time: 'Next update at {{time}}',
    live_update_next_tooltip_on_date: 'Next update on {{date}}',
    default_live_update_schedule_title: 'Default LiveUpdate schedule',
    usage_pending_credits: 'Pending credit units (in flight, not yet billable)',
    usage_schedule_sum_note:
      'Daily + weekly + monthly credit units should match this month’s total once all billable runs are posted.',
    usage_schedule_sum_mismatch: 'Breakdown sum {{sum}} vs this month’s total {{month}} — totals can differ briefly while runs are posting.',
    usage_percent_80_chip: '80%+ used',
    live_update_alert_settings_title: 'LiveUpdate Email Notifications',
    live_update_alert_settings_subtitle:
      'Defaults for new validations apply when you turn liveUpdate on; you can still change alerts on each report. Applies to Platform email only.',
    live_update_alert_criteria_title: 'When',
    live_update_alert_criteria_webhook_title: 'Notify me when…',
    live_update_alert_new_articles: 'New Links are reported',
    live_update_alert_risk_change: 'Validation risk indicator changed',
    live_update_alert_risk_threshold: 'For these risk levels:',
    live_update_alert_threshold_ALL: 'All risk levels',
    live_update_alert_threshold_HIGH_RISK: 'High risk',
    live_update_alert_threshold_INVESTIGATE: 'Investigate',
    live_update_alert_threshold_INCONCLUSIVE: 'Inconclusive',
    live_update_alert_threshold_CLEAR: 'Clear',
    live_update_alert_recipients_title: 'Who',
    live_update_alert_recipient_enabled_user: 'User who enabled LiveUpdate',
    live_update_alert_recipient_owner_admins: 'Account Owner and Admin',
    live_update_alert_recipient_all_validators: 'All validators on the validation',
    live_update_alert_recipient_owner: 'Account owner and admin',
    live_update_alert_recipient_specific: 'Selected users',
    live_update_alert_recipient_custom_email: 'Custom email address',
    live_update_alert_custom_email_label: 'Email address',
    live_update_alert_custom_email_placeholder: 'name@company.com',
    live_update_alert_custom_email_hint:
      'When selected, LiveUpdate notifications are also sent to this address.',
    live_update_alert_need_one_recipient: 'Select at least one recipient.',
    live_update_alert_summary_risk_change:
      "You'll be emailed when this validation's risk level changes.",
    live_update_alert_summary_new_articles_all_levels:
      "You'll be emailed when a new article is found at any risk level.",
    live_update_alert_summary_new_articles_levels:
      "You'll be emailed when a new article is found at {{levels}} risk level(s).",
    live_update_alert_summary_recipient_enabled_user: 'the user who enabled LiveUpdate',
    live_update_alert_summary_recipient_owners: 'account owners and admins',
    live_update_alert_summary_recipient_custom: '{{email}}',
    live_update_alert_summary_recipient_default: 'the selected recipients',
    live_update_alert_custom_email_invalid: 'Enter a valid email address.',
    live_update_alert_save: 'Save',
    live_update_alert_saved: 'LiveUpdate alert settings saved',
    live_update_alert_save_failed: 'Could not save alert settings',
    live_update_alert_need_one_criterion:
      'Choose at least one alert condition (for example new articles or risk change).',
    live_update_alert_use_company_defaults: 'Use company default alert settings',
    live_update_alert_validation_override_hint:
      'These settings apply to this validation only. Company defaults are under Profile → LiveUpdate.',
    user_management: 'User management',
    user_plural: 'users',
    user_type: 'access type',
    validation: 'validation',
    validation_plural: 'validations',
    validation_date: 'last validation date',
    violence: 'violence',
    year: 'year',
    year_plural: 'years',
    yellow: 'yellow',
    yes: 'yes',
    quantity: 'Quantity',
    pricing_details: 'Pricing details',
    item: 'Item',
    unit_price: 'Unit price',
    amount: 'Amount',
    total: 'Total',
    total_validation_period: 'Total validation period',
    validation_report: 'Report status',
    search_languages: 'Languages',
    total_links: '{{totalLinks}} Links',
    links: "Links",
    link: "Link",
    verified_estimate: {
      verifying: 'Verifying...',
      within_hours: 'Verified within {{hours}}h',
      within_monday: 'Verified by Monday 9 am',
    },
    pdf_report: {
      header: 'Online Media Report',
      powered_by: 'Powered by',
      view_on_twitter: 'View on Twitter',
      posted_on: 'Posted On',
      is_subject: 'is participant',
      not_subject: 'is mentioned',
      missconduct: 'Misconduct',
      subTopics: "sub Topics",
      found_on: 'Found On',
      from: 'From',
      links_analysed: 'Links Analyzed',
      created_by: 'Report created by {{name}}',
      english: 'english',
      french: 'french',
      spanish: 'spanish',
      portuguese: 'portuguese',
      arabic: 'arabic',
      german: 'german',
      italian: 'italian',
      russian: 'russian',
      how_to_read_this_report: 'How to read this report',
      pep_card_title: 'Politically Exposed Person',
    },
    sources: 'Sources',
  },
  options: {
    role: {
      talent_acquisition: 'Talent Acquisition',
      executive: 'Executive / VP',
      hr_consultant: 'HR Consultant',
      other: 'Other',
    },
  },
  actions: {
    switch_to_light_mode: 'Switch to light mode',
    switch_to_dark_mode: 'Switch to dark mode',
  },
  verbs: {
    accepted: 'accepted',
    add: 'add',
    add_individual: 'Add Individual',
    add_organization: 'Add Organization',
    add_without_company: 'Add without organization',
    added: 'added',
    apply: 'apply',
    archive: 'archive',
    archived: 'archived',
    back: 'back',
    back_to: 'back to',
    cancel: 'Cancel',
    save: 'Save',
    changed: 'changed',
    change_access_type: 'change access type',
    change_activity_status: 'change activity status',
    remove_access: 'Remove Access',
    grant_access: 'Grant Access',
    change_plan: 'change plan',
    change_plan_capitalized: 'Change plan',
    changed_plural: 'changed',
    close: 'close',
    confirm: 'Confirm',
    confirmed: 'confirmed',
    contact_us: 'contact us',
    continue: 'continue',
    connect: 'connect',
    created_by: 'created by',
    deactivate: 'deactivate',
    decline: 'decline',
    declined: 'declined',
    declined_plural: 'declined',
    disable: 'disable',
    disconnect: 'disconnect',
    denied: 'Denied',
    update_privacy: 'Switch to ',
    ok: 'OK',
    delete: 'delete',
    edit: 'edit',
    enable: 'enable',
    enroll: 'enroll',
    filter: 'filter',
    finalize: 'finalize',
    finish: 'finish',
    get_started: 'get started',
    go_back: 'go back',
    go_to: 'go to',
    invite: 'invite',
    in_progress: 'In Progress',
    last_validated: 'last update',
    last_validated_on: 'Last update on',
    loading: 'loading',
    login: 'log in',
    login_with: 'log in with',
    logout: 'log out',
    new_individual: 'New Individual',
    new_organization: 'New Organization',
    pending: 'pending',
    published_on: 'Published on {{date}}',
    no_publish_date: 'No publish date',
    language: 'Language of the Article',
    purchase: 'purchase',
    reactivate: 'reactivate',
    refused: 'declined',
    remind: 'remind',
    remove: 'remove',
    revoke: 'revoke',
    run_validation: 'run validation',
    send: 'send',
    send_code: 'Send code',
    sending: 'sending',
    sent: 'sent',
    show: 'Show',
    started: 'started',
    submit: 'submit',
    update: 'update',
    updated: 'Updated',
    verify: 'Verify',
    verifying: 'Verifying',
    switching: 'switching',
    updated_feminine: 'Updated',
    upgrade_plan: 'Upgrade plan',
    select_plan: 'Select a plan',
    upload_image: 'upload new image',
    update_individual: 'Update individual',
    update_organization: 'Update Organization',
    update_validation: 'Update Validation',
    update_information: 'Update Information',
    validated: 'validated',
    validated_by: 'validated by',
    reviewed_by: 'Reviewed by',
    validated_feminine_plural: 'validated',
    validate_new_individual: 'Validate New Individual',
    validate_as_new_individual: 'Validate as New',
    validate_individual: 'Validate Individual',
    validate_new_organization: 'Validate New Organization',
    validate_organization: 'Validate Organization',
    view: 'view',
    cancel_subscription: 'Cancel subscription',
    add_to_plan: 'Add to plan',
    finalize_purchase: 'Finalize purchase',
    make_admin: 'Make admin',
    make_delegate: 'Make delegate',
    unarchive: 'Unarchive',
  },
  country: {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo (DRC)',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Cote d'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curacao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Vatican City',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Laos',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macau',
    MK: 'North Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russia',
    RW: 'Rwanda',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'São Tomé and Príncipe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South sandwich islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Surinam',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Eswatini (Swaziland)',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syria',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Virgin Islands (British)',
    VI: 'Virgin islands (U.S.)',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
};

export default glossary;
